import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "../shared/loader";
import {useAccount,useConnect} from 'wagmi';
const walletType=process.env.REACT_APP_WALLET_TYPE
const ProtectedRoute = ({ children }) => {
    const {isLoading}=useConnect()
    const {isConnecting,isDisconnected,isReconnecting}=useAccount()
    
  const history = useHistory();
  const { userProfileInfo, gettingUserInfo } = useSelector(
    (store) => store.userConfig
  );
  if (
    (walletType === "non_custodial" &&
    ((!userProfileInfo|| !userProfileInfo?.id || isDisconnected) && !gettingUserInfo && !isConnecting && !isReconnecting && !isLoading))
  ) {
    history.replace("/");
    history.push("/welcome");
    return <></>;
  }
  if ((walletType === "non_custodial" && (gettingUserInfo || isConnecting || isReconnecting)) || !userProfileInfo|| !userProfileInfo?.id) {
    return (
      <div className="loader">
        <Loader />
      </div>
    );
  }
  return <>{children}</>;
};

export default ProtectedRoute;
